import React, { useEffect, useState } from "react";
import "./Signup.css";
import { HttpService } from "../../service/HttpService";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Input, Button } from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import Header from "../../Common/Header/Header";
const Signup = () => {
  useEffect(() => {
    getVendors();
  }, [0]);
  const history = useHistory();
  const httpService = new HttpService();
  const [obj, setObj] = useState({});
  const [options, setOptions] = useState([]);
  const [vendors, setVendors] = useState([]);
  const { handleSubmit, errors, control } = useForm({ mode: "onBlur" });

  const getVendors = () => {
    httpService.getApi2("vendor").then(
      (response) => {
        setVendors(response.data.content);
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const save = () => {
    let formData = new FormData();
    for (const property in obj) {
      if (obj[property] !== undefined) formData.append(property, obj[property]);
    }

    formData.append("loginType", "Application");
    formData.append("activated", true);
    httpService.signUpApi("users/register", formData).then(
      (response) => {
        // localStorage.setItem("token", response.data.id_token)
        history.push("/");
        console.log(response.data);
      },
      (error) => {
        console.log(error);
      }
    );
  };

  return (
    <>
      <Header isBackBtnShow={true} loggedInUser={false} />
      <div className="signup_sec">
        <Formik
          initialValues={{
            email: "",
            password: "",
            vendor: "",
          }}
          validationSchema={Yup.object().shape({
            email: Yup.string()
              .email("Email is invalid")
              .required("Email is required"),
            password: Yup.string()
              .min(6, "Password must be at least 6 characters")
              .required("Password is required"),
          })}
          onSubmit={(fields) => {
            obj.email = fields.email;
            obj.firstName = fields.firstName;
            obj.lastName = fields.lastName;
            obj.password = fields.password;
            obj.username = fields.email;
            obj.activated = true;
            setObj(obj);
            save();
          }}
          render={({ errors, status, touched }) => (
            <Form className="signUpForm">
              <h1 className="text-center text-uppercase m-2  p-2">Register</h1>
              <div className="form-group">
                <label htmlFor="firstName">First Name</label>
                <Field
                  name="firstName"
                  type="text"
                  className={
                    "form-control" +
                    (errors.firstName && touched.firstName ? " is-invalid" : "")
                  }
                />
                <ErrorMessage
                  name="First Name"
                  component="div"
                  className="invalid-feedback"
                />
              </div>

              <div className="form-group">
                <label htmlFor="lastName">Last Name</label>
                <Field
                  name="lastName"
                  type="text"
                  className={
                    "form-control" +
                    (errors.lastName && touched.lastName ? " is-invalid" : "")
                  }
                />
                <ErrorMessage
                  name="lastName"
                  component="div"
                  className="invalid-feedback"
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email</label>
                <Field
                  name="email"
                  type="text"
                  className={
                    "form-control" +
                    (errors.email && touched.email ? " is-invalid" : "")
                  }
                />
                <ErrorMessage
                  name="email"
                  component="div"
                  className="invalid-feedback"
                />
              </div>
              <div className="form-group">
                <label htmlFor="password">Password</label>
                <Field
                  name="password"
                  type="password"
                  className={
                    "form-control" +
                    (errors.password && touched.password ? " is-invalid" : "")
                  }
                />
                <ErrorMessage
                  name="password"
                  component="div"
                  className="invalid-feedback"
                />
              </div>
              <div className="form-group">
                <label htmlFor="confirmPassword">Confirm Password</label>
                <Field
                  name="confirmPassword"
                  type="password"
                  className={
                    "form-control" +
                    (errors.confirmPassword && touched.confirmPassword
                      ? " is-invalid"
                      : "")
                  }
                />
                <ErrorMessage
                  name="confirmPassword"
                  component="div"
                  className="invalid-feedback"
                />
              </div>

              <div className="form-group mb-2">
                <Button type="submit" className="btn  login_btn">
                  Sign Up
                </Button>
              </div>
              {/* <div className="or_sec text-center">
                            <span className="text-uppercase text-bold">or</span>
                        </div>
                        <div className="social-logins">
                            <span><i class="fab fa-facebook-f"></i></span>
                            <span><i className="fab fa-google-plus-g"></i></span>
                        </div> */}

              <p style={{ color: "#c94d3d" }}>
                Have an account ?{" "}
                <Link
                  style={{
                    textDecoration: "none",
                    color: "#c94d3d",
                    fontWeight: 800,
                  }}
                  to="/"
                >
                  Sign in
                </Link>
              </p>
            </Form>
          )}
        />
      </div>
    </>
  );
};
export default Signup;
